<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
            <li>最新消息</li>
          </ul>
        </div>
      </div>

      <div class="bodyContent">
        <div class="container">
          <div v-show="!isEmpty">
            <h1>最新消息</h1>
            <section class="normalList">
              <ul class="notice_list">
                <li v-for = "(noticeListData,$index) in paginationNoticeDatas" :key="noticeListData.id"  @click="clickListener (noticeListData, $index)"   >
                  <div class="wrap">
                    <div class="hd">
                      <b>{{noticeListData.announcement_category.title}}</b>
                      <span>{{new Date(noticeListData.starts_at).toLocaleDateString()}}</span>
                    </div>
                    <div class="content">
                      <h2>
                        {{noticeListData.title}}
                      </h2>
                      <p>
                        -  {{noticeListData.overview}}
                      </p>
                    </div>
                  </div>
                  <router-link v-bind:to="'/news/' +noticeListData.id" class="fullLink"></router-link>
                </li>
              </ul>
            </section>
            <div class="pagiContainer">
              <v-pagination
              v-model="currentPage"
              :page-count="totalPages"
              :classes="bootstrapPaginationClasses"
              ></v-pagination>
            </div>
          </div>

          <section  v-show="isEmpty" class="emptyPage">
            <div class="wrap">
              <figure>
                <img src="@/assets/images/status_empty_notification.png" alt="目前沒有內容，敬請期待！">
                <figcaption>
                  目前沒有內容，敬請期待！
                </figcaption>
              </figure>
            </div>
          </section>

        </div>
      </div>
    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import vPagination from 'vue-plain-pagination'

export default {
  components: { vPagination },

  name: 'async',
  metaInfo () {
    return {

      title: '最新消息 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '最新消息 | 一刻鯨選' },
        { property: 'og:site_name', content: '最新消息 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '一刻鯨選，行動新課堂，15分鐘聆聽新知，深入淺出，充實每一刻！打破學習框架，隨選隨聽，商管投資、文史賞析、生活陶冶，療癒心靈、充實大腦，浩瀚知識洋，即刻探索！' }

      ]
    }
  },

  data () {
    return {
      noticeListDatas: [],
      currentPage: 1, // 當前頁數
      totalPages: 2, // 總共頁數
      paginationNoticeDatas: [], // 分頁後資料
      isEmpty: false,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      }
    }
  },
  updated () {
    if (this.api_current_page !== this.currentPage) {
      this.paginationNoticeDatas = []
      this.allCount = this.noticeListDatas.length

      let i = (this.currentPage - 1) * 12

      if (this.allCount > this.currentPage * 12) { // 最多12筆
        this.allCount = this.currentPage * 12
      }

      for (i; i < this.allCount; i++) {
        this.paginationNoticeDatas.push(this.noticeListDatas[i])
      }

      this.api_current_page = this.currentPage
    }
  },
  created () {
    this.axios
      .get(this.$store.getters.baseURL + 'announcements')
      .then(response => {
        this.noticeListDatas = response.data
        this.allCount = this.noticeListDatas.length
        this.totalPages = Math.ceil(this.noticeListDatas.length / 12)
        let size = this.noticeListDatas.length
        let i
        if (this.noticeListDatas.length > 12) {
          size = 12
        }
        for (i = 0; i < size; i++) {
          this.paginationNoticeDatas.push(this.noticeListDatas[i])
        }

        if (this.paginationNoticeDatas.length === 0) {
          this.isEmpty = true
        }
      })
      .catch(error => console.log('log:' + error))
  },
  methods: {

    clickListener (item, index) {
      // alert(item.id);
      const id = item.id
      // this.$router.push({ path: "/course" });
      // this.$store.commit('courseId', id)
      this.$router.push({ path: '/news/' + id, params: { id } })
    }

  },
  mounted () {
    $('body').removeClass('index')
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/views/NoticeList.vue